import React, { useCallback } from 'react'
import {
    OverContainer,
    OverSpan,
    Text,
    SectionImage,
    SectionTypography,
    Error,
    ErrorTypography,
    Content,
    ContentButton,
    OverIcons,
    Over,
    Spacing,
    Image,
} from './styles'
import Button from 'src/components/common/Button'
import { useNavigate } from 'react-router-dom'
import { FooterSocial } from 'src/constants'
import { MapSocial } from 'src/pages/DetailedProfile/ProfileSection/mapSocial'
import ImageOne from 'src/assets/404Error/ROBOT404.avif'
import { useTranslations } from "src/provider/LocaleProvider";

export const Section404 = () => {
  const t = useTranslations()
    const navigate = useNavigate()
    const handleChange = useCallback(() => {
        navigate('/')
    }, [])
    return (
        <Over>
            <OverContainer>
                <OverSpan></OverSpan>
                <Text paddingTop={'xspacesFull'}>
                    <SectionImage>
                        <Image src={ImageOne} alt={'ImageOne'} />
                    </SectionImage>
                    <SectionTypography>
                        <Error>
                            <ErrorTypography
                                variant={'h1'}
                                fontSize={[
                                    'xtitlle',
                                    'xtitlle',
                                    'xxxtitle',
                                    'xsuper',
                                ]}
                                fontWeight={800}
                            >
                                404 ERROR
                            </ErrorTypography>
                            <ErrorTypography
                                variant={'h2'}
                                fontSize={[
                                    'xtitlle',
                                    'xtitlle',
                                    'xxtitle',
                                    'xxtitle',
                                ]}
                                fontWeight={600}
                            >
                                {t('not.title')}
                            </ErrorTypography>
                            <Content
                                variant={'h3'}
                                fontSize={[
                                    'xxxmedium',
                                    'xxxmedium',
                                    'xxxmedium',
                                    'xmedium',
                                ]}
                                fontWeight={400}
                            >
                                {t('not.content')}
                            </Content>
                            <ContentButton marginTop={'large'}>
                                <Button
                                    Content={t('not.button')}
                                    onClick={handleChange}
                                />
                            </ContentButton>
                        </Error>
                    </SectionTypography>
                </Text>
            </OverContainer>
            <OverIcons>
                <Spacing>
                    {FooterSocial.map((social) => {
                        return <MapSocial key={social.id} {...social} />
                    })}
                </Spacing>
            </OverIcons>
        </Over>
    )
}
